import { DropMenuType } from "src/app/common/enums/enums";
import { DropMenuItem } from "./DropMenuItem";

export class DropMenu{
    type        : DropMenuType = DropMenuType.Default;   
    menuItems   : DropMenuItem[];
    ref         : any;
}